export default __webpack_public_path__ + "static/media/personal_pic.02b8afc5.jpeg";